import LocationRouter from './LocationRouter';
import { getPageTitle, getPageDescription } from './utils';
export { getPageTitle, getPageDescription };

export default LocationRouter;
